import React from "react";
import CheckoutPageComponent from "../../components/CheckoutComponent/CheckoutComponent";
import CheckoutPage from "./CheckoutAll";
import styled from "styled-components";
import { useParams, useSearchParams } from "react-router-dom";
import { useQuery } from "@apollo/client";
import {
  GET_PAYMENT_LINK_BY_SHORTCODE,
  GET_PAYMENT_TRANSACTION_BY_REFERENCE,
} from "../../graphql/queries/paymentlink";
import { environment } from "../../env";
import { checkoutProduct, selectedProduct } from "../../store/nanostore";
import { useStore } from "@nanostores/react";
import { Overlay, LoadingSpinner } from "../../pages/AddUserPage/AddUser";
import ErrorComponent from "../../components/NotFound";
import { stripePromise } from "../../components/StripeElement";
import CheckoutPageComponentReview from "../../components/CheckoutComponent/CheckoutComponentReview";
import { StatusMessage } from "../../components/CheckoutComponent/data";
import { usePDF } from "react-to-pdf";

const CheckoutStatus = () => {
  const [params] = useSearchParams();
  const { id } = useParams();

  const { loading, error, data } = useQuery(
    GET_PAYMENT_TRANSACTION_BY_REFERENCE,
    {
      variables: {
        ...environment.paymentService,
        id: id || params.get("payment_intent"),
        type: params.get("method") || "stripe",
      },
    }
  );
  const { targetRef } = usePDF({ filename: "page.pdf" });

  React.useEffect(() => {
    if (!loading && data) {
      checkoutProduct.set(data?.paymentTransactionByReference);
    }
  }, [loading, data]);

  console.log(data?.paymentTransactionByReference);

  const totalPrice = data?.paymentTransactionByReference?.reduce(
    (acc: any, cur: any) => acc + cur.amount,
    0
  );
  const transaction = data?.paymentTransactionByReference?.[0] || {};

  return loading || (!data && !error) ? (
    <Overlay>
      <LoadingSpinner />
    </Overlay>
  ) : !error ? (
    <Wrapper>
      <CheckoutPageComponentReview
        products={data?.paymentTransactionByReference}
        totalPrice={totalPrice}
        targetRef={targetRef}
      />
      <CenterItem>
        {StatusMessage(transaction?.status, "", targetRef)}
      </CenterItem>
    </Wrapper>
  ) : (
    <ErrorComponent />
  );
};

export default CheckoutStatus;

export const Wrapper = styled.div`
  display: flex;
  height: 100vh;
  margin-left: auto;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    height: 100%;
  }
`;

export const CenterItem = styled.div`
  display: flex;
  height: 100vh;
  margin-left: auto;
  flex: 1;
  justify-content: center;
  align-items: center;

  .content {
    width: 250px;
    flex-direction: row !important;
  }
`;
